import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const RecoStylingItem = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  .btn {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .veVideo {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #000;

      .loading-icon {
        display: none !important;
      }
    }

    .img,
    .veVideo .xgplayer {
      padding-bottom: 133.34%;
    }
  }

  .play-icon {
    position: absolute;
    top: 8px;
    right: 8px;
    pointer-events: none;
    z-index: 1;
  }

  &.isLoaded {
    .play-icon {
      opacity: 0;
    }

    .veVideo.is-player-play + .area-poster {
      opacity: 0;
      z-index: 0;
    }
  }

  .textBox {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 11px 12px 12px;
    text-align: left;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
    }

    .username {
      position: relative;
      text-align: left;
      line-height: 120%;
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      z-index: 1;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .play-icon {
      top: ${mixin.pxToVw('8')};
      right: ${mixin.pxToVw('8')};
    }
  }
`;
